import { ChangeEvent, FocusEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, useTheme } from '@mui/material';
import { MIN_BPM, MAX_BPM } from './constants';
import { BpmSelectorProps } from './types';
import { BpmInput, BpmSlider, BpmSliderContainer } from './styles';

const BpmSelector = ({ onChange, value }: BpmSelectorProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const handleInputChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      const newValue = parseInt(target.value, 10);
      if (Number.isNaN(newValue)) {
        return;
      }
      onChange(newValue);
    },
    [onChange]
  );

  const handleInputBlur = useCallback(
    ({ target }: FocusEvent<HTMLInputElement>) => {
      const newValue = parseInt(target.value, 10);
      if (newValue < MIN_BPM) {
        onChange(MIN_BPM);
      }
      if (newValue > MAX_BPM) {
        onChange(MAX_BPM);
      }
    },
    [onChange]
  );

  return (
    <BpmSliderContainer>
      <BpmSlider
        min={MIN_BPM}
        max={MAX_BPM}
        value={value}
        onChange={({ target }: { target?: { value: number } }) => {
          if (!target) {
            return;
          }
          onChange(target.value);
        }}
      />
      <BpmInput
        type="number"
        inputProps={{
          inputMode: 'numeric',
          min: MIN_BPM,
          max: MAX_BPM,
        }}
        endAdornment={
          <Typography color={theme.palette.grey[200]} fontSize="12px">
            {t('aiMusicGenerator:tagLabels:bpm')}
          </Typography>
        }
        value={value}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        size="small"
      />
    </BpmSliderContainer>
  );
};

export default BpmSelector;
